import { Action, ActionType } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { Observable, of, OperatorFunction } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { toReduxError } from '@universal/errors';
import { MyVehiclesResponse, VehicleObject, VehicleAlertsListResponse } from '@appTypes/myVehiclesType';
import { Actions, actions } from '@redux/modules/myVehicles';
import { TypedEpic } from './types';

export const getMyVehiclesEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_MY_VEHICLES),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getMyVehicles.request>[]
    >,
    switchMap(() =>
      fromApiRequest((signal) =>
        apiClient.get<MyVehiclesResponse>(ApiType.apimMembershipApi, {
          signal,
          url: ApiPaths[ApiType.apimMembershipApi].vehicles,
        }),
      ).pipe(
        map((response) => actions.getMyVehicles.success(response.data)),
        catchError((err) =>
          of(
            actions.getMyVehicles.failure(
              toReduxError(
                err,
                'Oops, vi har problemer med motoren... Kunne ikke hente kjøretøyene dine! Ta kontakt med kundesenteret hvis problemet fortsetter!',
              ),
            ),
          ),
        ),
      ),
    ),
  );

export const getVehicleEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_VEHICLE),
    withLatestFrom(state$) as unknown as OperatorFunction<Action<any>, ActionType<typeof actions.getVehicle.request>[]>,
    switchMap(([action]) =>
      fromApiRequest((signal) =>
        apiClient.get<VehicleObject>(ApiType.apimMembershipApi, {
          signal,
          url: ApiPaths[ApiType.apimMembershipApi].vehiclesDelete(action.payload), // Note: using same path pattern for get single vehicle
        }),
      ).pipe(
        map((response) => actions.getVehicle.success(response.data)),
        catchError((err) =>
          of(
            actions.getVehicle.failure(
              toReduxError(
                err,
                'Oops, vi har problemer med motoren... Kunne ikke hente kjøretøyet ditt! Ta kontakt med kundesenteret hvis problemet fortsetter!',
              ),
            ),
          ),
        ),
      ),
    ),
  );

export const getVehicleAlertsEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_VEHICLE_ALERTS),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getVehicleAlerts.request>[]
    >,
    switchMap(() =>
      fromApiRequest((signal) =>
        apiClient.get<VehicleAlertsListResponse>(ApiType.apimMembershipApi, {
          signal,
          url: ApiPaths[ApiType.apimMembershipApi].vehicleAlerts,
        }),
      ).pipe(
        map((response) => actions.getVehicleAlerts.success(response.data)),
        catchError((err) =>
          of(
            actions.getVehicleAlerts.failure(
              toReduxError(
                err,
                'Oops, vi har problemer med motoren... Kunne ikke hente varslingsinnstillinger. Ta kontakt med kundesenteret hvis problemet fortsetter!',
              ),
            ),
          ),
        ),
      ),
    ),
  );

export const epics: TypedEpic[] = [getMyVehiclesEpic, getVehicleEpic, getVehicleAlertsEpic];
